import { apiRequest } from '@/shared/api';

import type { Match } from '../model/types';

export function fetchOpenMatches(): Promise<Match[]> {
  return apiRequest<Match[]>('/matches/open');
}

/**
 * Сыгранные матчи сегодняшнего дня Серии — витрина вкладки «Завершённые».
 *
 * Что считается сыгранным, решает сервер: между окончанием матча и показом
 * результата стоит задержка публикации из `game_setting` (ГДД §5.6), и
 * фильтруй мы здесь по `status`, игрок увидел бы счёт раньше срока.
 * Форма ответа та же, что у `/matches/open` — отдельный тип не нужен.
 */
export function fetchFinishedMatches(): Promise<Match[]> {
  return apiRequest<Match[]>('/matches/finished');
}
